// extracted by mini-css-extract-plugin
export default {"wrapper":"popover_wrapper__Z0xcY","anchor":"popover_anchor__hY9M9","overlay":"popover_overlay__kzz+e","box":"popover_box__5x33g"};